import useSWR from "swr";
import { formatMarkdown } from "@/components/formatMarkdown";
import { Template } from "@/types/template";
import styles from "./index.module.css";

export const Templates2 = () => {
  const { data: templates } = useSWR<Template[]>(
    "/api/template?sort=popular&limit=6&tag=template"
  );

  return (
    <section id="templates" className={styles.section}>
      <div className={styles.sectionHead}>
        <div className={styles.sectionKicker}>one-click templates</div>
        <h2 className={styles.sectionTitle}>
          Or skip the build —
          <br />
          <em>fork a template.</em>
        </h2>
        <p className={styles.sectionSub}>
          Ready-made starter projects and self-hostable apps. Fork, deploy, done.
        </p>
      </div>
      <div className={styles.tplGrid}>
        {templates?.map(t => (
          <a
            key={t.id}
            href={`/r/${t.id}`}
            className={`${styles.tplCard} plausible-event-name=L2_TemplateClicked`}
          >
            <div
              className={styles.tplStripe}
              style={{ background: "#7274ea" }}
              aria-hidden="true"
            />
            <div className={styles.tplBody}>
              <div className={styles.tplTagRow}>
                {t.logo && (
                  <img src={t.logo} alt={`${t.name} logo`} className={styles.tplLogo} />
                )}
                {t.tags?.[0] && <span className={styles.tplTag}>{t.tags[0]}</span>}
              </div>
              <div className={styles.tplName}>{t.name}</div>
              <div className={styles.tplDesc}>{formatMarkdown(t.intro)}</div>
              <span className={styles.tplBtn}>Deploy →</span>
            </div>
          </a>
        ))}
      </div>
    </section>
  );
};
